import Icon from '../components/Icon';
import PlaceImage from '../components/PlaceImage';
import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const PHONE    = '9445879508';
const WA_PHONE = '919445879508';

const tourTypes = [
  { icon:'heart', title:'Honeymoon Tours', desc:'Slow mornings, misty lakes and a little time just for two.', img:'kodaikanal', place:'Kodaikanal Lake', detail:'Made for two', to:'/tours?type=Honeymoon', tag:'A favourite escape' },
  { icon:'users', title:'Family Tours', desc:'Easy days, scenic stops and memories for every generation.', img:'ooty', place:'Ooty Lake', detail:'Together is better', to:'/tours?type=Family' },
  { icon:'compass', title:'Group Tours', desc:'Bring your favourite people. We’ll take care of the journey.', img:'pillar-rocks', place:'Pillar Rocks, Kodaikanal', detail:'Room for everyone', to:'/tours?type=Group' },
  { icon:'temple', title:'Pilgrimage Tours', desc:'Meaningful journeys to South India’s timeless sacred places.', img:'srirangam', place:'Srirangam', detail:'Travel with purpose', to:'/tours?type=Pilgrimage' },
  { icon:'mountain', title:'Hill Station Tours', desc:'Trade the everyday rush for fresh air and greener views.', img:'valparai', place:'Valparai tea estates', detail:'Take the scenic route', to:'/tours?category=Hill%20Stations' },
  { icon:'briefcase', title:'Corporate Tours', desc:'A change of scene for your team, planned around your schedule.', img:'wayanad', place:'Wayanad', detail:'Beyond the office', to:'/contact?trip=Corporate%20team%20outing', cta:'Plan a team outing' },
];

const destinations = [
  { name:'Kodaikanal', icon:'mountain', img:'/images/destinations/kodaikanal.jpg', tag:'Base Route' },
  { name:'Madurai',    icon:'temple', img:'/images/destinations/madurai.jpg', tag:'Temple City' },
  { name:'Rameswaram', icon:'compass', img:'/images/destinations/rameswaram.jpg', tag:'Sacred Island' },
  { name:'Munnar',     icon:'leaf', img:'/images/destinations/munnar.jpg', tag:'Kerala Hills' },
  { name:'Ooty',       icon:'compass', img:'/images/destinations/ooty.jpg', tag:'Queen of Hills' },
  { name:'Sabarimala', icon:'temple', img:'/images/destinations/sabarimala.jpg', tag:'Pilgrimage' },
  { name:'Srirangam',  icon:'temple', img:'/images/destinations/srirangam.jpg', tag:'Divya Desam' },
  { name:'Kanyakumari',icon:'compass', img:'/images/destinations/kanyakumari.jpg', tag:"Land's End" },
  { name:'Velankanni', icon:'temple', img:'/images/destinations/velankanni.jpg', tag:'Shrine Basilica' },
  { name:'Tirupati',   icon:'temple', img:'/images/destinations/tirupati.jpg', tag:'Divya Desam' },
  { name:'Palani',     icon:'temple', img:'/images/destinations/palani.jpg', tag:'Murugan Temple' },
];

const vehicles = [
  { name:'4-Seater Car',  seats:'4',  img:'/images/destinations/tata-zest.jpg', type:'Tata Zest', best:'Couples & Small Families' },
  { name:'7-Seater SUV',  seats:'7',  img:'/images/destinations/toyota-innova.jpg', type:'Toyota Innova',      best:'Families' },
  { name:'12-Seater Van', seats:'12', img:'/images/destinations/tata-winger.jpg', type:'Tata Winger',      best:'Large Groups' },
  { name:'25-Seater Coach Van', seats:'25', img:'/images/destinations/sml-coach-van.jpg', type:'SML Coach Van',          best:'Group Tours' },
];

export default function Home() {
  return (
    <div className="home page-enter">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero__bg" style={{ backgroundImage: "url('/images/destinations/kodaikanal.jpg')" }} />
        <div className="hero__overlay" />
        <div className="hero__content container">
          <div className="hero__badge fade-up"> Kodai Road  Kodaikanal — Est. 2003</div>
          <h1 className="hero__title fade-up delay-1">
            Explore South India<br />
            with <em>Maggi Cabs</em>
          </h1>
          <p className="hero__desc fade-up delay-2">
            From Kodaikanal to Kanyakumari, Rameswaram to Munnar — trusted tours across
            South India since 2003. Call Anbu Kumar anytime.
          </p>
          <div className="hero__ctas fade-up delay-3">
            <a href={`https://wa.me/${WA_PHONE}?text=Hi%20Anbu%20Kumar!%20I%20want%20to%20book%20a%20tour.`}
               target="_blank" rel="noreferrer" className="btn-primary">
               Book on WhatsApp
            </a>
            <a href={`tel:+91${PHONE}`} className="btn-outline">
               Call +91 {PHONE}
            </a>
          </div>
        </div>
        <div className="hero__stats">
          <div className="container hero__stats-inner">
            {[['20+','Years'],['75','Destinations'],['79+','Tour Packages'],['24/7','Available']].map(([n,l]) => (
              <div key={l} className="hero__stat">
                <strong>{n}</strong><span>{l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── QUICK CALL ── */}
      <section className="quick-book">
        <div className="container quick-book__inner">
          <div className="quick-book__text"><strong>Anbu Kumar:</strong> Available 24/7 for all bookings</div>
          <div className="quick-book__actions">
            <a href={`tel:+91${PHONE}`} className="btn-green"> +91 {PHONE}</a>
            <a href={`https://wa.me/${WA_PHONE}`} target="_blank" rel="noreferrer" className="btn-primary"> WhatsApp</a>
          </div>
        </div>
      </section>

      {/* ── DESTINATIONS ── */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <div>
              <p className="eyebrow">Where We Go</p>
              <h2 className="display-title">Our Destinations</h2>
              <div className="amber-line" />
            </div>
            <Link to="/tours" className="btn-green">View All Tours →</Link>
          </div>
          <div className="home-dest-grid">
            {destinations.map(d => (
              <Link key={d.name} to={`/tours?${d.name === 'Tirupati' ? 'search' : 'destination'}=${encodeURIComponent(d.name)}`} className="home-dest-card">
                <PlaceImage src={d.img} alt={d.name} loading="lazy" />
                <div className="home-dest-overlay" />
                <div className="home-dest-body">
                  <span className="home-dest-tag">{d.tag}</span>
                  <span className="home-dest-name">{d.name}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── TOUR TYPES ── */}
      <section className="section-pad journey-section" aria-labelledby="journeys-title">
        <div className="container">
          <div className="journey-heading">
            <div><p className="eyebrow">Find your kind of journey</p>
            <h2 className="display-title" id="journeys-title">Good company.<br /><em>Great escapes.</em></h2></div>
            <div className="journey-heading__aside"><p>From a quiet weekend for two to a road trip with everyone. Choose a journey that feels like you.</p>
            <Link to="/tours">Explore all packages <Icon name="arrow" size={18} /></Link></div>
          </div>
          <div className="tours-grid">
            {tourTypes.map((t, index) => (
              <Link key={t.title} to={t.to} className="journey-card">
                <div className="journey-card__photo">
                  <PlaceImage src={`/images/destinations/${t.img}.jpg`} alt={t.place} loading="lazy" />
                  {t.tag && <span className="journey-card__tag">{t.tag}</span>}
                  <span className="journey-card__location"><Icon name="pin" size={14} />{t.place}</span>
                </div>
                <div className="journey-card__body">
                  <div className="journey-card__meta"><span><Icon name={t.icon} size={18} />{t.detail}</span><span className="journey-card__number">0{index + 1}</span></div>
                  <h3>{t.title}</h3><p>{t.desc}</p>
                  <div className="journey-card__cta"><span>{t.cta || 'Discover packages'}</span><span className="journey-card__arrow"><Icon name="arrow" size={19} /></span></div>
                </div>
              </Link>
            ))}
          </div>
          <div className="journey-help"><span><Icon name="compass" size={26} /><span><strong>A different route in mind?</strong> Let’s make it your own.</span></span><Link to="/contact">Plan a custom trip <Icon name="arrow" size={18} /></Link></div>
        </div>
      </section>

      {/* ── FLEET ── */}
      <section className="section-pad fleet-section">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Travel in Comfort</p>
            <h2 className="display-title">Our Fleet</h2>
            <div className="amber-line center" />
            <p className="section-desc">4 vehicle types for every group size — all AC, all maintained.</p>
          </div>
          <p className="fleet-photo-note">Model reference photos. Vehicle appearance and configuration may vary.</p>
          <div className="fleet-grid">
            {vehicles.map(v => (
              <div key={v.name} className="vehicle-card card">
                <div className="vehicle-card__img">
                  <PlaceImage src={v.img} alt={v.type} loading="lazy" />
                  <span className="vehicle-card__seats"> {v.seats} Seats</span>
                </div>
                <div className="vehicle-card__body">
                  <h3>{v.name}</h3>
                  <p className="vehicle-card__type">{v.type}</p>
                  <p className="vehicle-card__best">Best for: <strong>{v.best}</strong></p>
                  <a href={`https://wa.me/${WA_PHONE}?text=Hi!%20I'd%20like%20to%20book%20the%20${encodeURIComponent(v.type + " (" + v.seats + " seats)")}`}
                     target="_blank" rel="noreferrer" className="btn-primary">Book This Vehicle</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="why-section section-pad">
        <div className="container">
          <div className="why-grid">
            <div className="why-content">
              <p className="eyebrow">Why Choose Maggi Cabs</p>
              <h2 className="display-title light">20+ Years on<br />South India Roads</h2>
              <div className="amber-line" />
              <p>Anbu Kumar has been running tours since 2003 — from the winding ghats to Kodaikanal, temple circuits to beach pilgrimages. His deep knowledge of every route means you're always safe and on time.</p>
              <div className="why-features">
                {['Experienced & Licensed Drivers','AC Vehicles — All Types','Transparent Pricing','24/7 Availability','75 Destinations Covered','Local Area Expertise'].map(f => (
                  <div key={f} className="why-feature">
                    <span className="why-feature__check">✓</span>{f}
                  </div>
                ))}
              </div>
              <a href={`tel:+91${PHONE}`} className="btn-primary" style={{marginTop:'1.5rem'}}>
                 Call Anbu Kumar Now
              </a>
            </div>
            <div className="why-image">
              <PlaceImage src="/images/destinations/Owner.png" alt="Kodaikanal" />
              <div className="why-image__card">
                <strong>Anbu Kumar</strong>
                <span>Owner & Senior Driver</span>
                <span>Est. 2003</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Happy Travellers</p>
            <h2 className="display-title">What Our Guests Say</h2>
            <div className="amber-line center" />
          </div>
          <div className="reviews-grid">
            {[
              { name:'Priya & Rahul',   loc:'Chennai',    stars:5, text:'Our Kodaikanal honeymoon was perfect! Anbu Kumar drove us safely through the mountain roads. Knew every scenic spot. Highly recommended!' },
              { name:'Karthik Family',  loc:'Coimbatore', stars:5, text:'Booked the 7-seater for Rameswaram. Comfortable vehicle, punctual driver, fair price. Will definitely book again!' },
              { name:'College Group',   loc:'Madurai',    stars:5, text:'Group trip to Ooty for 20 students. Got a great deal on the mini coach. Driver was patient and fun. Unforgettable trip!' },
              { name:'Suresh Kumar',    loc:'Bangalore',  stars:5, text:'Sabarimala pilgrimage arranged perfectly. On time to Pamba and pickup was smooth. Great service for such an important trip.' },
              { name:'Meena & Family',  loc:'Trichy',     stars:5, text:'Srirangam + Thanjavur in one day — perfectly planned. Second time using Maggi Cabs. Always trustworthy!' },
              { name:'IT Team Outing',  loc:'Salem',      stars:5, text:'Corporate trip to Munnar for 22 people. Zero issues — transport, timing, coordination. The team loved it!' },
            ].map((r,i) => (
              <div key={i} className="review-card card">
                <div className="review-card__stars">{'★'.repeat(r.stars)}</div>
                <p className="review-card__text">"{r.text}"</p>
                <div className="review-card__author">
                  <strong>{r.name}</strong>
                  <span>{r.loc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="cta-section__bg" style={{ backgroundImage: "url('/images/destinations/kodaikanal.jpg')" }} />
        <div className="container cta-section__content">
          <p className="eyebrow">Ready to Explore?</p>
          <h2 className="display-title light">Book Your Tour Today!</h2>
          <p>Call or WhatsApp Anbu Kumar — 75 destinations, 79+ packages, 24/7 available.</p>
          <div className="cta-section__btns">
            <a href={`tel:+91${PHONE}`} className="btn-primary"> +91 {PHONE}</a>
            <a href={`https://wa.me/${WA_PHONE}`} target="_blank" rel="noreferrer" className="btn-outline"> WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}
